<template>
  <cargo-dialog
    v-el-drag-dialog
    custom-class="bill-address-dialog"
    :visible.sync="innerVisible"
    :title="$t('SeaExport.ConsigneeShipperAndNotifyAddress')"
    width="1000px"
    :close-on-click-modal="false"
    append-to-body
    :can-maximize="true"
    @close="innerVisible = false"
  >
    <el-form label-width="120px" label-position="left" style="width: 100%;margin-bottom: 5px">
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item :label="$t('CargoMsg.Cargo_AuthorizedClient')">
            <cargo-company-select
              v-if="useEmptyCustomerCmpList || (customerCmpList && customerCmpList.length > 0)"
              no="1"
              :method-params="{customer:true,active:true}"
              :check-credit="true"
              :job="job"
              :default-value="job.customerId||''"
              :static-options="customerCmpList"
              @change="p=>{filter.partnerId=p.value}"
            />
            <cargo-company-select
              v-if="(!customerCmpList || customerCmpList.length === 0) && !useEmptyCustomerCmpList"
              no="1"
              :method-params="{customer:true}"
              :default-value="filter.partnerId||''"
              @change="p=>{filter.partnerId=p.value}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('CargoMsg.Cargo_DestinationPort')">
            <div style="display: flex; align-items: center;">
              <cargo-advance-select
                no="2"
                :disabled="filter.checkAllPort"
                :select-type="(this.filter.lob === 'SE' || this.filter.lob === 'SI' || this.filter.lob === 'IE') ? selectTypeNames.basic_data_Seaport : selectTypeNames.basic_data_Airport"
                filterable
                :default-value="filter.pod"
                style="width: 100%; max-width: 220px;"
                @parentCallBack="p=>filter.pod=p.value"
              />
              <el-checkbox v-model="filter.checkAllPort" :label="$t('CargoMsg.Cargo_NoRestriction')" style="margin-left: 8px; white-space: nowrap;" @change="checkPort" />
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('SeaExport.Sales')">
            <div style="display: flex; align-items: center;">
              <cargo-user-select
                ref="sales"
                :disabled="filter.checkAllSales"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'sales'}"
                :default-value="filter.salesId||''"
                filterable
                style="width: 100%; max-width: 220px;"
                @change="p=>{filter.salesId = p.value;}"
              />&nbsp;
              <el-checkbox v-model="filter.checkAllSales" :label="$t('CargoMsg.Cargo_NoRestriction')" style="margin-left: 8px; white-space: nowrap;" @change="checkSales" />
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item :label="$t('CargoMsg.Cargo_ShipperId')">
            <el-input v-model="filter.shipperCode" no="3" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('CargoMsg.Cargo_ConsigneeId')">
            <el-input v-model="filter.consigneeCode" no="4" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('CargoMsg.Cargo_NotifyId')">
            <el-input v-model="filter.notifyCode" no="5" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item :label="$t('CargoMsg.Cargo_ShipperSName')">
            <el-input v-model="filter.shipperName" no="13" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('CargoMsg.Cargo_ConsigneeSName')">
            <el-input v-model="filter.consigneeName" no="14" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('CargoMsg.Cargo_NotifyPartySName')">
            <el-input v-model="filter.notifyName" no="15" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-show="showPayment" :gutter="10">
        <el-col :span="8">
          <el-form-item :label="$t('CargoMsg.Cargo_PaymentCode')">
            <el-input v-model="filter.paymentCode" no="paymentCode" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('CargoMsg.Cargo_PaymentName')">
            <el-input v-model="filter.paymentName" no="paymentName" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col style="text-align: left">
          <el-button no="6" type="primary" @click="toQuery">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
          <el-button no="7" type="primary" @click="reset">{{ $t('CargoMsg.Cargo_Empty') }}</el-button>
        </el-col>
      </el-row>
    </el-form>
    <cargo-ag-grid
      :grid-options="gridOptions"
      :grid-params.sync="gridParams"
      :column-defs="columnDefs"
      :row-data="rowData"
      style="width:100%;min-height:300px"
      @gridReady="params=>{gridApi=params.api}"
    />
    <span slot="footer">
      <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
        <div>
          <el-button v-permission="['button_JobBillAddress_addBillAddress']" no="addMailingAddress" type="primary" @click="addMailingAddress">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
          <el-button v-permission="['button_JobBillAddress_editBillAddress']" no="editMailingAddress" type="primary" @click="editMailingAddress">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
          <el-button v-permission="['button_JobBillAddress_deleteBillAddress']" no="deleteMailingAddress" type="danger" @click="deleteMailingAddress">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
        </div>
        <div>
          <el-button
            no="8"
            type="primary"
            @click="choose(['shipperInfo','shipperCode', 'shipperCountryCode', 'shipperCityName', 'shipperZipCode',
                            'shipperProvinceCode', 'shipperEori', 'shipperStreetNo', 'shipperContactsType', 'shipperContacts',
                            'shipperVipCode', 'shipperMscCode', 'shipperCompanyCode', 'shipperInttraCode'])"
          >{{ $t('SeaExport.CopyShipper') }}</el-button>
          <el-button
            no="9"
            type="primary"
            @click="choose(['consigneeInfo','consigneeCode', 'consigneeCountryCode', 'consigneeCityName', 'consigneeZipCode',
                            'consigneeProvinceCode', 'consigneeEori', 'consigneeStreetNo', 'consigneeContactsType', 'consigneeContacts',
                            'consigneeVipCode', 'consigneeMscCode', 'consigneeCompanyCode', 'consigneeInttraCode'])"
          >{{ $t('SeaExport.CopyConsignee') }}</el-button>
          <el-button
            no="10"
            type="primary"
            @click="choose(['notifyInfo','notifyCode', 'notifyCountryCode', 'notifyCityName', 'notifyZipCode',
                            'notifyProvinceCode', 'notifyEori', 'notifyStreetNo', 'notifyContactsType', 'notifyContacts',
                            'notifyVipCode', 'notifyMscCode', 'notifyCompanyCode', 'notifyInttraCode' ])"
          >{{ $t('SeaExport.CopyNotify') }}</el-button>
          <el-button
            v-show="showPayment"
            no="showPayment"
            type="primary"
            @click="choose(['paymentInfo','paymentCode', 'paymentCountryCode', 'paymentCityName', 'paymentZipCode',
                            'paymentProvinceCode', 'paymentEori', 'paymentStreetNo', 'paymentContactsType', 'paymentContacts',
                            'paymentVipCode', 'paymentMscCode', 'paymentCompanyCode', 'paymentInttraCode'])"
          >{{ $t('CargoMsg.Cargo_SelectPayment') }}</el-button>
          <el-button
            no="11"
            type="primary"
            @click="choose(['shipperInfo','shipperCode','consigneeInfo','consigneeCode','notifyInfo','notifyCode',
                            'shipperCountryCode','shipperCityName', 'shipperZipCode', 'shipperProvinceCode', 'shipperEori', 'shipperStreetNo','shipperContactsType', 'shipperContacts',
                            'consigneeCountryCode', 'consigneeCityName', 'consigneeZipCode', 'consigneeProvinceCode', 'consigneeEori', 'consigneeStreetNo', 'consigneeContactsType', 'consigneeContacts',
                            'notifyCountryCode', 'notifyCityName', 'notifyZipCode', 'notifyProvinceCode', 'notifyEori', 'notifyStreetNo', 'notifyContactsType', 'notifyContacts',
                            'paymentInfo','paymentCode', 'paymentCountryCode', 'paymentCityName', 'paymentZipCode', 'paymentProvinceCode', 'paymentEori', 'paymentStreetNo', 'paymentContactsType', 'paymentContacts',
                            'shipperVipCode', 'shipperMscCode', 'shipperCompanyCode', 'shipperInttraCode',
                            'consigneeVipCode', 'consigneeMscCode', 'consigneeCompanyCode', 'consigneeInttraCode',
                            'notifyVipCode', 'notifyMscCode', 'notifyCompanyCode', 'notifyInttraCode',
                            'paymentVipCode', 'paymentMscCode', 'paymentCompanyCode', 'paymentInttraCode'
            ])"
          >{{ $t('CargoMsg.Cargo_Select') }}</el-button>
          <el-button no="12" @click="innerVisible=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
        </div>
      </div>
    </span>

    <mailing-address-maintain-dialog
      :visible.sync="mailingAddressMaintainDialog.visible"
      :dialog-title="mailingAddressMaintainDialog.title"
      :form="mailingAddressMaintainDialog.form"
      :type="mailingAddressMaintainDialog.type"
      :job="job"
      @callback="toQuery"
    />
  </cargo-dialog>
</template>

<script>

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { batchDelMailingAddress, findMailingAddressByUuid, getMailingAddressList } from '@/api/partner/mailingAddress'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import CargoDialog from '@/components/Cargo/Common/CargoDialog'
import mailingAddressMaintainDialog from '@/components/Cargo/Job/mailingAddressMaintainDialog.vue'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect.vue'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { getGridSelectedIds } from '@/utils/agGrid'

export default {
  name: 'BillAddressDialog',
  components: { cargoUserSelect, CargoDialog, cargoAdvanceSelect, cargoCompanySelect, mailingAddressMaintainDialog },
  props: {
    visible: { type: Boolean, required: true },
    job: { type: Object, default: null },
    params: { type: Object, default: null },
    ownPermission: { type: Boolean, required: false },
    showPayment: { type: Boolean, required: false },
    customerCmpList: { type: Array, default: () => { return [] } },
    useEmptyCustomerCmpList: { type: Boolean, required: false, default: false }
  },
  data() {
    return {
      innerVisible: false,
      selectTypeNames: TYPE_NAMES,
      oldShipperCode: '',
      oldConsigneeCode: '',
      oldNotifyCode: '',
      filter: {
        lob: 'SE',
        partnerId: '',
        pod: '',
        salesId: '',
        shipperCode: '',
        consigneeCode: '',
        notifyCode: '',
        officeId: '',
        mbl: false,
        isPortFilter: true,
        shipperLine1: '',
        consigneeLine1: '',
        notifyLine1: '',
        shipperName: '',
        consigneeName: '',
        notifyName: '',
        paymentCode: '',
        paymentName: '',
        checkAllPort: true,
        checkAllSales: true
      },
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        rowHeight: 150,
        context: {
          componentParent: this
        },
        onRowClicked: this.selectItemClickHandler,
        onRowSelected: this.selectItemClickHandler
      },
      selectItem: null,
      rowData: [],
      gridApi: null,
      mailingAddressMaintainDialog: {
        visible: false,
        title: '',
        type: '',
        form: {}
      }
    }
  },
  computed: {
    columnDefs() {
      const list = [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('baseInfo.mailingAddress.shipperCode'),
          field: 'shipperCode',
          width: 100
        }, {
          headerName: this.$t('baseInfo.mailingAddress.shipperInfo'),
          field: 'shipperInfo',
          width: 200,
          cellRenderer: this.multipleDataRellRenderer
        }, {
          headerName: this.$t('baseInfo.mailingAddress.consigneeCode'),
          field: 'consigneeCode',
          width: 100
        }, {
          headerName: this.$t('baseInfo.mailingAddress.consigneeInfo'),
          field: 'consigneeInfo',
          width: 200,
          cellRenderer: this.multipleDataRellRenderer
        },
        {
          headerName: this.$t('baseInfo.mailingAddress.pod1'),
          field: 'pod',
          cellRenderer: (params) => {
            if (params.data) {
              const englishName = params.data['podEnglishName']
              if (englishName && englishName.trim() !== '') {
                return englishName
              }
            }
            return ''
          },
          filterParams: {},
          filterValueGetter: (params) => {
            if (params.data) {
              const englishName = params.data['podEnglishName']
              if (englishName && englishName.trim() !== '') {
                return englishName
              }
            }
            return ''
          }
        }, {
          headerName: this.$t('baseInfo.mailingAddress.notifyCode'),
          field: 'notifyCode',
          width: 100
        }, {
          headerName: this.$t('baseInfo.mailingAddress.notifyInfo'),
          field: 'notifyInfo',
          width: 200,
          cellRenderer: this.multipleDataRellRenderer
        }
      ]
      if (this.showPayment) {
        list.push({
          headerName: this.$t('CargoMsg.Cargo_PaymentCode'),
          field: 'paymentCode',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_PaymentInfo'),
          field: 'paymentInfo',
          width: 200,
          cellRenderer: this.multipleDataRellRenderer
        })
      }
      return list
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.init()
      }
      this.selectItem = null
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.init()
      this.toQuery()
    }
  },
  methods: {
    init() {
      if (!this.innerVisible) {
        return
      }
      this.filter.partnerId = ''
      this.filter.pod = ''
      this.filter.shipperCode = ''
      this.filter.shipperCode = ''
      this.filter.consigneeCode = ''
      this.filter.notifyCode = ''
      this.filter.officeId = ''
      this.filter.shipperLine1 = ''
      this.filter.consigneeLine1 = ''
      this.filter.notifyLine1 = ''
      this.filter.shipperName = ''
      this.filter.consigneeName = ''
      this.filter.notifyName = ''
      if (this.params) {
        if (this.params.hasOwnProperty('shipperCode')) {
          if (this.params.shipperCode !== this.oldShipperCode) {
            this.filter.shipperCode = this.params.shipperCode
            this.oldShipperCode = this.params.shipperCode
          } else {
            this.filter.shipperCode = ''
          }
        }
        if (this.params.hasOwnProperty('consigneeCode')) {
          if (this.params.consigneeCode !== this.oldConsigneeCode) {
            this.filter.consigneeCode = this.params.consigneeCode
            this.oldConsigneeCode = this.params.consigneeCode
          } else {
            this.filter.consigneeCode = ''
          }
        }
        if (this.params.hasOwnProperty('notifyCode')) {
          if (this.params.notifyCode !== this.oldNotifyCode) {
            this.filter.notifyCode = this.params.notifyCode
            this.oldNotifyCode = this.params.notifyCode
          } else {
            this.filter.notifyCode = ''
          }
        }
        if (this.params.hasOwnProperty('mbl')) {
          this.filter.mbl = this.params.mbl
        }
      }
      if (LocalStorageUtilsNew.hasConfiguration('billAddressCheckPod')) {
        this.filter.checkAllPort = Boolean(LocalStorageUtilsNew.getConfiguration('billAddressCheckPod'))
      }
      if (LocalStorageUtilsNew.hasConfiguration('billAddressCheckSales')) {
        this.filter.checkAllSales = Boolean(LocalStorageUtilsNew.getConfiguration('billAddressCheckSales'))
      }
      const job = this.job
      if (this.job) {
        this.filter.lob = job.lob
        this.filter.salesId = job.sales
        let customerId = 0
        let destPort = ''
        if (job.lob === 'SE' || job.lob === 'SI') {
          if (this.filter.mbl && !!job.mblOnly) {
            customerId = job.customerId
            destPort = job.destinationPortCode
          } else if (this.filter.mbl) {
            customerId = job.destinationAgent
            destPort = job.destinationPortCode
          } else {
            customerId = job.customerId
            destPort = job.destinationPortCode
          }
        } else if (job.lob === 'AE') {
          if (this.filter.mbl) {
            if (job.operateType === AirExportConstants.CONSOLE.code || job.operateType === AirExportConstants.BACK_TO_BACK.code) {
              customerId = job.destinationAgent
              destPort = job.destinationPortCode
            } else if (job.operateType === AirExportConstants.DIRECT.code) {
              customerId = job.customerId
              destPort = job.destinationPortCode
            }
          } else {
            customerId = job.customerId
            destPort = job.destinationPortCode
          }
        } else if (job.lob === 'IE') {
          destPort = job.dischargingPortCode
        }
        this.filter.partnerId = customerId
        if (job.lob !== 'RE' && job.lob !== 'RI') {
          if (job.lob === 'AE') {
            this.filter.pod = destPort
          } else {
            this.filter.pod = destPort || job.dischargingPortCode
          }
        } else {
          this.filter.pod = ''
        }
      }
    },
    selectItemClickHandler(event) {
      if (!event.data) {
        return
      }
      this.selectItem = event.data
    },
    reset() {
      if (!this.filter) return
      for (const key in this.filter) {
        this.filter[key] = ''
      }
    },
    toQuery() {
      const loading = getLoading4Cxt(this)
      this.filter.officeId = this.$store.getters.currentOfficeId
      this.filter.shipperLine1 = this.filter.shipperName
      this.filter.consigneeLine1 = this.filter.consigneeName
      this.filter.notifyLine1 = this.filter.notifyName
      this.filter.hasChooseOwnTransceiverPermission = this.ownPermission
      getMailingAddressList(this.filter).then(res => {
        this.rowData = res.data.list
      }).finally(() => {
        this.selectItem = null
        if (this.gridApi) {
          this.gridApi.clearFocusedCell()
        }
        loading.close()
      })
    },
    multipleDataRellRenderer(params) {
      if (params.value !== undefined) {
        return params.value.replace(/<br\/>/g, '<br/>')
      }
      return ''
    },
    choose(fieldKeys) {
      if (!this.selectItem) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      const data = {}
      for (const key of fieldKeys) {
        data[key] = this.selectItem[key]
        if (data[key] && typeof data[key] === 'string') {
          data[key] = data[key].replace(new RegExp('<br\s*/>', 'g'), '\n')
        }
      }
      this.$emit('callback', data)
      this.innerVisible = false
    },
    addMailingAddress() {
      this.mailingAddressMaintainDialog.form = {}
      this.mailingAddressMaintainDialog.title = this.$t('baseInfo.mailingAddress.addMailingAddress')
      this.mailingAddressMaintainDialog.type = 'add'
      this.mailingAddressMaintainDialog.visible = true
    },
    editMailingAddress() {
      const self = this
      if (!self.selectItem) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      const uuid = this.selectItem.uuid
      findMailingAddressByUuid(uuid).then(result => {
        self.mailingAddressMaintainDialog.form = { ...result.data }
        self.mailingAddressMaintainDialog.type = 'edit'
        self.mailingAddressMaintainDialog.title = self.$t('baseInfo.mailingAddress.editMailingAddress')
        self.mailingAddressMaintainDialog.visible = true
      })
    },
    deleteMailingAddress() {
      const self = this
      getGridSelectedIds(this.gridOptions, 'uuid').then(ids => {
        if (ids.length < 1) {
          self.$message.error(self.$t('common.tips.hasOneAtleast'))
        }
        this.$confirm(this.$t('CargoMsg.Cargo_DeleteConfirmation'), this.$t('common.tips.confirm'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning'
        }).then(() => {
          const loading = getLoading4Cxt(this)
          batchDelMailingAddress(ids).then(res => {
            self.toQuery()
            this.$message.success(this.$t('common.tips.deleteSuccess'))
          }).finally(() => {
            loading.close()
          })
        }).catch(() => {
          this.$message.info(this.$t('common.tips.cancelDelete'))
        })
      })
    },
    checkPort() {
      LocalStorageUtilsNew.setConfiguration('billAddressCheckPod', this.filter.checkAllPort)
    },
    checkSales() {
      LocalStorageUtilsNew.setConfiguration('billAddressCheckSales', this.filter.checkAllSales)
    }
  }
}
</script>

<style lang="scss">
#app .app-main-inner .bill-address-dialog .el-dialog__body {
  padding: 10px;
}
#app #tab-mawb .bill-address-dialog .el-form-item__content {
  width: auto !important;
}
#app #tab-hawb .bill-address-dialog .el-form-item__content {
  width: auto !important;
}
.app-main-content .details-view .main-content {
  .bill-address-dialog {
    .title:before {
      width: 0px !important;
    }
    .title {
      padding-left: 0px;
      line-height: 24px;
      font-size: 18px !important;
      color: #333;
      margin-bottom: 0px;
    }
  }
}
</style>
